import { useSelector } from "react-redux"
import { departmentsResource } from "../../helpers/configRoutes/backend_helper"
import {
  UPDATE_DEPARTMENT,
  RESET_DEPARTMENT,
  SET_DEPARTMENTS
} from "./actionTypes"

export const update_department = department => {
  return {
    type: UPDATE_DEPARTMENT,
    payload: department,
  }
}

export const set_departments = departments => {
  return {
    type: SET_DEPARTMENTS,
    payload: departments,
  }
}

export const reset_department = () => {
  return {
    type: RESET_DEPARTMENT,
  }
}

export const get_departments = () => {
  return async (dispatch, getState) => {
    const departments = getState().department.departments

    // Ya tengo datos, no llamo al backend
    if (departments && departments.length > 0) {
      return departments
    }

    // Llamo al backend si no hay datos
    const response = await departmentsResource('get', {}, false, true)

    dispatch({
      type: SET_DEPARTMENTS,
      payload: response
    })

    return response
  }
}
